import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppConfig } from '@config/AppConfigContext';
import { fetchJson, getAuthHeader, joinUrl } from '@hooks/requests/utils/_partner_api_client';
import { PARTNER_TEAM_INVITATIONS_PATH } from '@hooks/requests/utils/paths';

export interface RevokeInvitationParams {
  invitationId: string;
}

export const useRevokeInvitationMutation = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { allyApi, auth0Audience } = useAppConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ invitationId }: RevokeInvitationParams): Promise<void> => {
      if (!allyApi) throw new Error('Missing allyApi configuration');
      const authHeader = await getAuthHeader(getAccessTokenSilently, auth0Audience);

      await fetchJson<void>(
        joinUrl(allyApi, `${PARTNER_TEAM_INVITATIONS_PATH}/${encodeURIComponent(invitationId)}`),
        authHeader,
        'Failed to revoke the invitation',
        { method: 'DELETE' }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PARTNER_TEAM_INVITATIONS_PATH] });
    },
  });
};

export default useRevokeInvitationMutation;
